import { ReactComponent as Dashboard } from "assets/activeHomeIcons/legalHome/dashboardactive.svg";
import { ReactComponent as Calendar } from "assets/activeHomeIcons/legalHome/calenderactive.svg";
import { ReactComponent as Employee } from "assets/activeHomeIcons/legalHome/People 1.svg";
import { ReactComponent as Matter } from "assets/activeHomeIcons/legalHome/Matter 1.svg";
import { ReactComponent as Task } from "assets/activeHomeIcons/legalHome/taskactive.svg";
import { ReactComponent as ResourcePlanning } from "assets/activeHomeIcons/legalHome/Resource 1.svg";
import { ReactComponent as TimeSheet } from "assets/activeHomeIcons/legalHome/Timesheet 1.svg";
import { ReactComponent as Policy } from "assets/activeHomeIcons/legalHome/companyPolicyactive.svg";
import { ReactComponent as Approvals } from "assets/activeHomeIcons/legalHome/approvalsactive.svg";
import { ReactComponent as Appraisal } from "assets/activeHomeIcons/legalHome/performanceAppraisalactive.svg";
import { ReactComponent as Client } from "assets/activeHomeIcons/legalHome/clientactive.svg";
import { ReactComponent as Account } from "assets/activeHomeIcons/Legal Settings/Account 1.svg";
import { ReactComponent as Role } from "assets/activeHomeIcons/Legal Settings/Permission 1.svg";
import { ReactComponent as Leave } from "assets/activeHomeIcons/Legal Settings/Leave 1.svg";
import { ReactComponent as Holiday } from "assets/activeHomeIcons/Legal Settings/Holiday 1.svg";
import { ReactComponent as ChargeoutRate } from "assets/activeHomeIcons/Legal Settings/Chargeout 1.svg";
import { ReactComponent as ChangeManager } from "assets/activeHomeIcons/Legal Settings/ChangeManageractive.svg";
import { ReactComponent as JobDescription } from "assets/activeHomeIcons/Legal Settings/Job desc 1.svg";
import { ReactComponent as Currency } from "assets/activeHomeIcons/Legal Settings/Currency 1.svg";
import { ReactComponent as Billingentity } from "assets/activeHomeIcons/Legal Settings/Other entity 1.svg";
import { ReactComponent as Recruitment } from "assets/activeHomeIcons/Legal HR/Recruitment 1.svg";
import { ReactComponent as HRpolicies } from "assets/activeHomeIcons/Legal HR/Policy 1.svg";
import { ReactComponent as Assets } from "assets/activeHomeIcons/Legal HR/Asset 1.svg";
import { ReactComponent as Onboarding } from "assets/activeHomeIcons/Legal Reports/Onboarding1.svg";
import { ReactComponent as MyDeclaration } from "assets/activeHomeIcons/Legal Reports/AnnualDec1.svg";
import { ReactComponent as Document } from "assets/activeHomeIcons/legalHome/My Folder 1.svg";

// Main Menu Icons
import { ReactComponent as HomeIcon } from "assets/activeHomeIcons/MainMenuIcons/Homeactive.svg";
import { ReactComponent as Settings } from "assets/activeHomeIcons/MainMenuIcons/Settingsactive.svg";
import { ReactComponent as Trends } from "assets/activeHomeIcons/MainMenuIcons/HRresourcesactive.svg";
import { ReactComponent as Report } from "assets/activeHomeIcons/MainMenuIcons/Reportactive.svg";
import { ReactComponent as AnalyticsIcon } from "assets/activeHomeIcons/MainMenuIcons/Analyticsactive.svg";
import { ReactComponent as Incident } from "../assets/Incident 1.svg";
import { ReactComponent as Disciplinary } from "../assets/Disciplinary 1.svg";

const styleIcon = {
  height: "24px",
  width: "24px",
};

const iconTypes = {
  //Legal Home
  // MainMenu
  home: HomeIcon,
  settings: Settings,
  trends: Trends,
  report: Report,
  analytics: AnalyticsIcon,

  dashboard: Dashboard,
  calendar: Calendar,
  employee: Employee,
  matter: Matter,
  task: Task,
  resourceplanning: ResourcePlanning,
  timesheet: TimeSheet,
  companypolicy: Policy,
  approvals: Approvals,
  appraisal: Appraisal,
  client: Client,
  account: Account,
  document: Document,
  // Legal Settings
  role: Role,
  leave: Leave,
  holiday: Holiday,
  chargeoutrate: ChargeoutRate,
  changemanager: ChangeManager,
  jobdescription: JobDescription,
  currency: Currency,
  billingentity: Billingentity,
  // Legal HR
  exceptionreport: Recruitment,
  policy: HRpolicies,
  assets: Assets,
  // Legal Reports & Analytics
  onboarding: Onboarding,
  mydeclaration: MyDeclaration,
  myincident: Incident,
  mydisciplinary: Disciplinary,
  disciplinary: Disciplinary,
  incident: Incident,
};

const ActiveIcons = ({ name, ...props }) => {
  let ActiveIcons = iconTypes[name];
  if (!ActiveIcons) {
    return null;
  }
  return <ActiveIcons style={styleIcon} {...props} />;
};
export default ActiveIcons;